import { useGlobalContext } from "../../../../../Context/Context";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Button from "../../../../Custom/Button/Button";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import reorderImg from "../../../../../picture/reorder.png";
import correctImg from "../../../../../picture/doneIconGreen.png";
import notifImg from "../../../../../picture/notif.png";
import wrongImg from "../../../../../picture/wrong.png";
import arrowImg from "../../../../../picture/NextLanguage.png";
import DokumentaOstalaOpremaVazeca from "./DokumentaOstalaOpremaVazeca";
import DokumentaOstalaOpremaArhivirana from "./DokumentaOstalaOpremaArhivirana";
import editImg from "../../../../picture/olovka.png";

const styles = {
  cell: { paddingTop: "5px", textAlign: "center", fontWeight: "bold" },
  smallCell: { width: "30px", textAlign: "center", height: "5vh" },
  icon: { width: "30px", height: "30px" },
  arrowImg: {
    transform: "rotate(90deg)",
    width: "15px",
  },
  expandedArrow: {
    transform: "rotate(270deg)",
    transition: "transform 0.3s ease",
  },
  actionCell: {
    width: "45px",
    minWidth: "45px",
    maxWidth: "45px",
    height: "45px",
    textAlign: "center",
    verticalAlign: "middle",
  },
  statusSquare: {
    width: "22px",
    height: "22px",
    margin: "0 auto",
  },
};

const mappingIcons = {
  correct: correctImg,
  wrong: wrongImg,
  notif: notifImg,
};

function TabelaOstalaOprema({
  data,
  setSredstvoId,
  selectedRows,
  setSelectedRows,
}) {
  const [sredstva, setSredstva] = useState([]);
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);
  const [columns, setColumns] = useState([
    "vrsta",
    "tip",
    "oznaka",
    "lokacija",
  ]);

  const checkedRows = selectedRows || [];
  const isCheckedAll =
    sredstva.length > 0 && checkedRows.length === sredstva.length;

  // Nova stanja zaExpandedRow
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [vazecaDokumenta, setVazecaDokumenta] = useState([]);
  const [arhiviranaDokumenta, setArhiviranaDokumenta] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);

  const { sredstvaOpremaPretraga, dictionary, baseUrl, apiKey, loggedUser } =
    useGlobalContext();

  useEffect(() => {
    if (!data || data.length === 0) return;

    let filtered = [...data];
    const sTerm = sredstvaOpremaPretraga?.pretraga?.toLowerCase();

    if (sTerm) {
      filtered = filtered.filter(
        (s) =>
          (s.naziv && s.naziv.toLowerCase().includes(sTerm)) ||
          (s.identifikacioni_broj &&
            s.identifikacioni_broj.toLowerCase().includes(sTerm)),
      );
    }

    // const mapped = filtered.map((item) => ({
    //   ...item,
    //   id: item.masina_id,
    //   idBroj: item.identifikacioni_broj,
    //   td: item.td || "empty",
    //   sn: item.sn || "empty",
    //   rg: item.rg || "empty",
    //   pu: item.pu || "empty",
    //   od: item.od || "empty",
    //   et: item.et || "empty"
    // }));

    const mapped = filtered.map((item) => ({
      ...item,
      id: item.masina_id,

      // NOVO: da kolona "oznaka" radi
      oznaka: item.identifikacioni_broj ?? item.oznaka ?? "",
      vrsta: item.naziv ?? item.vrsta ?? "",

      // (opciono) ako ti idBroj više ne treba, možeš ga obrisati
      // idBroj: item.identifikacioni_broj,

      td: item.td || "empty",
      sn: item.sn || "empty",
      rg: item.rg || "empty",
      pu: item.pu || "empty",
      od: item.od || "empty",
      et: item.et || "empty",
    }));

    setSredstva(mapped);
    setSelectedRows([]);
  }, [data, sredstvaOpremaPretraga]);

  const fetchDokumenta = useCallback(
    async (masina_id) => {
      if (!masina_id || !loggedUser) return;
      setLoadingDocs(true);
      try {
        const payload = {
          user_id: loggedUser.id,
          api_key: apiKey,
          masina_id: masina_id,
        };

        const { data } = await axios.post(
          `${baseUrl}/machines/read_documents.php`,
          payload,
        );

        if (data.status === 200) {
          setVazecaDokumenta(data.vazeca || []);
          setArhiviranaDokumenta(data.arhivirana || []);
        }
      } catch (error) {
        console.error("Greška pri učitavanju dokumenata:", error);
      } finally {
        setLoadingDocs(false);
      }
    },
    [baseUrl, apiKey, loggedUser],
  );

  useEffect(() => {
    const handleRefresh = () => {
      if (expandedRowId) {
        fetchDokumenta(expandedRowId);
      }
    };
    window.addEventListener("machineAdded", handleRefresh);
    return () => window.removeEventListener("machineAdded", handleRefresh);
  }, [expandedRowId, fetchDokumenta]);

  const handleRowClick = (masina_id) => {
    if (expandedRowId === masina_id) {
      // Zatvori ako je već otvoren
      setExpandedRowId(null);
      setVazecaDokumenta([]);
      setArhiviranaDokumenta([]);
    } else {
      // Otvori novi red
      setExpandedRowId(masina_id);
      fetchDokumenta(masina_id);
    }
  };

  const moveToArhivirani = async (item) => {
    const nazivDokumenta = item.naziv || "dokument";
    if (
      !window.confirm(
        `Da li ste sigurni da želite da arhivirate: ${nazivDokumenta}?`,
      )
    )
      return;

    const formData = new FormData();
    formData.append("document_id", item.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/archive_document.php`,
        formData,
      );
      if (data.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
      } else {
        alert("Greška sa servera: " + data.message);
      }
    } catch (error) {
      console.error("Greška pri arhiviranju:", error);
    }
  };

  const moveToVazeci = async (item) => {
    if (
      !window.confirm(
        `Vratiti dokument iz arhive: ${item.naziv || "dokument"}?`,
      )
    )
      return;

    const formData = new FormData();
    formData.append("document_id", item.id);
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);

    try {
      const { data } = await axios.post(
        `${baseUrl}/machines/restore_document.php`,
        formData,
      );
      if (data.status === 200) {
        window.dispatchEvent(new Event("machineAdded"));
      }
    } catch (error) {
      console.error("Greška pri vraćanju iz arhive:", error);
    }
  };

  const handleCheckRedniBrojevi = () =>
    setIsCheckedRedniBrojevi((prev) => !prev);

  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
    setSredstva([...sredstva].reverse());
  };

  // const handleReorderColumns = (index) => {
  //   const copy = [...columns];
  //   [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
  //   setColumns(copy);
  // };

  const handleReorderColumns = (index) => {
    const copy = [...columns];

    const a = copy[index];
    const b = copy[index + 1];

    const isTip = (x) => x === "tip";
    const isOznaka = (x) => x === "oznaka";
    const isPairMember = (x) => isTip(x) || isOznaka(x);

    // 1) Ako klikneš na TIP/OZNAKA jedan pored drugog -> samo swap između njih
    if (isPairMember(a) && isPairMember(b)) {
      [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
      setColumns(copy);
      return;
    }

    // Nađi gde su tip i oznaka
    const iTip = copy.indexOf("tip");
    const iOzn = copy.indexOf("oznaka");

    // Ako nešto fali (safety)
    if (iTip === -1 || iOzn === -1) {
      [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
      setColumns(copy);
      return;
    }

    const left = Math.min(iTip, iOzn);
    const right = Math.max(iTip, iOzn);

    // 2) Ako je klik na granici paketa (tj. menjaš ga sa levim ili desnim susedom)
    // Pomeri paket kao celinu za jedno mesto ulevo ili udesno
    if (index === left - 1) {
      // swap "nekaKolona" <-> (TIP,OZNAKA) kao blok
      const before = copy[left - 1];
      copy.splice(left - 1, 3, copy[left], copy[right], before);
      setColumns(copy);
      return;
    }

    if (index === right) {
      // swap (TIP,OZNAKA) <-> "nekaKolona" kao blok
      const after = copy[right + 1];
      copy.splice(left, 3, after, copy[left], copy[right]);
      setColumns(copy);
      return;
    }

    // 3) U svim ostalim slučajevima radi normalan swap
    [copy[index], copy[index + 1]] = [copy[index + 1], copy[index]];
    setColumns(copy);
  };

  const handleCheckRow = (id, e) => {
    e.stopPropagation();
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleCheckAll = () => {
    if (isCheckedAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(sredstva.map((z) => z.id));
    }
  };

  const getOverallDocStatus = (sredstvo) => {
    const keys = ["rg", "sn", "pu", "od", "td", "et"];

    if (keys.some((k) => sredstvo[k] === "wrong")) return "wrong";
    if (keys.some((k) => sredstvo[k] === "notif")) return "notif";

    const hasAny = keys.some((k) => sredstvo[k] && sredstvo[k] !== "empty");
    if (!hasAny) return "empty";

    return "correct";
  };

  const getAllNonGreenStatus = (sredstva) => {
    return sredstva.filter(
      (sredstvo) => getOverallDocStatus(sredstvo) !== "correct",
    );
  };

  const getBrojDokumenata = (sredstvo) => {
    const keys = ["rg", "sn", "pu", "od", "td", "et"];
    return keys.filter((k) => sredstvo[k] && sredstvo[k] !== "empty").length;
  };

  return (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
      }}
    >
      <thead>
        <tr
          style={{
            backgroundColor: "#fff",
            position: "sticky",
            top: -25,
            zIndex: 2,
          }}
        >
          <th style={{ width: "3%" }}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={{ width: "6%" }}>
            <div style={{ display: "flex" }}>
              <div onClick={handleCheckSort}>
                <Button active={isCheckedSort}>
                  <img
                    src={sortImg}
                    style={{ width: "30px", height: "30px" }}
                  />
                </Button>
              </div>
              <div onClick={handleCheckRedniBrojevi}>
                <Button active={isCheckedRedniBrojevi}>
                  <img
                    src={redniBrojeviImg}
                    style={{ width: "30px", height: "30px" }}
                  />
                </Button>
              </div>
            </div>
          </th>
          {/* <th style={styles.smallCell}>{dictionary["td"]}</th>
          <th style={styles.smallCell}>{dictionary["sn"]}</th>
          <th style={styles.smallCell}>{dictionary["rg"]}</th>
          <th style={styles.smallCell}>{dictionary["pu"]}</th>
          <th style={styles.smallCell}>{dictionary["od"]}</th>
          <th style={styles.smallCell}>@</th> */}
          {columns.map((col, index) => (
            <th
              style={{ ...styles.cell, position: "relative", width: "21.5%" }}
              key={index}
            >
              {dictionary[col]}
              {index < columns.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    right: "-20px",
                    width: "39px",
                    height: "39px",
                    zIndex: 1,
                  }}
                  onClick={() => handleReorderColumns(index)}
                >
                  <Button activation={true}>
                    <img
                      src={reorderImg}
                      style={{ width: "30px", height: "30px" }}
                    />
                  </Button>
                </div>
              )}
            </th>
          ))}
          <th colSpan={1}>{sredstva.length}</th>
          <th colSpan={1}>5{/* OVDE IDE BROJ NE-ZELENIH DOKUMENATA */}</th>
          <th colSpan={1}>
            <span style={{ fontSize: "15px" }}>555</span>
            {/* OVDE IDE ZBIR SVIH BROJEVA IZNAD STRELICE */}
          </th>
        </tr>
      </thead>
      <tbody>
        {sredstva.map((sredstvo, index) => (
          <>
            <tr
              key={sredstvo.id}
              style={{
                borderBottom: "1px solid #ddd",
                cursor: "pointer",
                backgroundColor:
                  expandedRowId === sredstvo.id ? "#f5f5f5" : "transparent",
              }}
              onClick={() => handleRowClick(sredstvo.id)}
            >
              <td style={styles.cell} onClick={(e) => e.stopPropagation()}>
                <input
                  type="checkbox"
                  checked={checkedRows.includes(sredstvo.id)}
                  onChange={(e) => handleCheckRow(sredstvo.id, e)}
                  style={{ width: "30px" }}
                />
              </td>
              <td
                style={{
                  padding: "5px",
                  textAlign: "start",
                  fontWeight: "bold",
                }}
              >
                {`${isCheckedRedniBrojevi ? sredstvo.redniBroj || index + 1 : index + 1}.`}
              </td>

              {/* {["td", "sn", "rg", "pu", "od", "et"].map((doc) => (
                <td key={doc} style={{ ...styles.smallCell, height: "30px" }}>
                  {sredstvo[doc] &&
                    sredstvo[doc] !== "empty" &&
                    mappingIcons[sredstvo[doc]] && (
                      <img
                        src={mappingIcons[sredstvo[doc]]}
                        style={styles.icon}
                      />
                    )}
                </td>
              ))} */}

              {columns.map((col, i) => (
                <td style={{ ...styles.cell, textAlign: "left" }} key={i}>
                  <span style={{ marginLeft: "5px" }}></span>
                  {sredstvo[col]}
                </td>
              ))}
              <td
                style={{
                  ...styles.actionCell,
                }}
              >
                <img src={editImg} style={{ width: "30px" }} />
              </td>
              <td
                style={{
                  ...styles.actionCell,
                }}
              >
                {(() => {
                  const status = getOverallDocStatus(sredstvo);

                  if (status === "empty") return null;

                  const bg =
                    status === "correct"
                      ? "#00b055ff" // zeleno
                      : status === "notif"
                        ? "#f1c40f" // žuto
                        : "#ff0000ff"; // crveno

                  return (
                    <div
                      style={{
                        ...styles.statusSquare,
                        backgroundColor: bg,
                      }}
                    />
                  );
                })()}
              </td>
              <td
                style={{
                  ...styles.actionCell,
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "45px",
                    gap: "2px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "15px",
                      fontWeight: "bold",
                      lineHeight: "12px",
                    }}
                  >
                    {getBrojDokumenata(sredstvo)}
                  </div>

                  <img
                    src={arrowImg}
                    style={{
                      width: "10px",
                      transform:
                        expandedRowId === sredstvo.id
                          ? "rotate(270deg)"
                          : "rotate(90deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </div>
              </td>
            </tr>

            {/* EXPANDED ROW SA DOKUMENTIMA */}
            {expandedRowId === sredstvo.id && (
              <tr
                style={{
                  zIndex: 0,
                  overflowY: "auto",
                  height: "300px",
                }}
              >
                <td
                  colSpan={columns.length + 9}
                  style={{ backgroundColor: "#fafafa", verticalAlign: "top" }}
                >
                  {loadingDocs ? (
                    <div>Učitavanje dokumenata...</div>
                  ) : (
                    <div style={{ padding: "10px" }}>
                      <DokumentaOstalaOpremaVazeca
                        dokumenta={vazecaDokumenta}
                        moveToArhivirani={moveToArhivirani}
                      />

                      <div>
                        <DokumentaOstalaOpremaArhivirana
                          dokumenta={arhiviranaDokumenta}
                          setDokumenta={setArhiviranaDokumenta}
                          moveToVazeci={moveToVazeci}
                        />
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </>
        ))}
      </tbody>
    </table>
  );
}

export default TabelaOstalaOprema;
